import React, { useState, useEffect } from "react";
declare var CADESCOMSignData: any;
import AccountInfo from "../Profile/AccountInfo";

import { useMutation } from "@tanstack/react-query";
import axios from "axios";

import { IDocumentModel } from "../Common/types";



export default function usePostAddSignature() {
    const post = (postData: IDocumentModel) => {
        return new Promise(async (resolve, reject) => {
            try {
                CADESCOMSignData(
                    postData.DocumentBase64,
                    postData.DocumentBase64,
                    AccountInfo.Thumbprint,
                    true,
                    postData.SignedData,
                    true,
                    async function (signInfo) {
                        try {
                            const response = await axios.post("/DocumentApi/AddSignature", {
                                SignInfo: signInfo,
                                DocId: postData.Id,
                            });
                            resolve(response.data);
                        } catch (err) {
                            reject(err);
                        }
                    }
                );
            } catch (err) {
                reject(err);
            }
        });
    };


    const mutation = useMutation({
        mutationKey: ["AddSignature"],
        mutationFn: post,
        onSuccess: (data) => {
            console.log("%c AddSignature успешно:", "color: #b885f2; font-weight: bold; font-size: 16px;");
        },
        onError: (error) => {
            console.log("%c AddSignature ошибка:", "color: #f08181; font-weight: bold; font-size: 16px;", error);
        },
    });

    return {
        ...mutation,
        error: mutation.error?.response?.data?.Error || mutation.error?.message || "Неизвестная ошибка",
    };
}